// extracted by mini-css-extract-plugin
module.exports = {"loading":"loading___29D3j","loadingWp":"loadingWp___3Lv1i","loadingImage":"loadingImage___1udtq","loadingText":"loadingText___3Jltz"};